// extracted by mini-css-extract-plugin
export default {"default":"skeleton-element__default___23_kl","loadingAnim":"skeleton-element__loadingAnim___1yYaZ"};